import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartItem } from "../modules/stores/interfaces/CartItem";
import { DraftOrder } from "../modules/stores/interfaces/DraftOrder";
import { DraftState } from "../modules/stores/interfaces/DraftState";
import { generateDraftCode } from "../utils/draft-code.utils";

const initialState: DraftState = {
    drafts: [],
};

const draftsSlice = createSlice({
    name: "drafts",
    initialState,
    reducers: {
        saveDraft: (state, action: PayloadAction<Omit<DraftOrder, "id"> & { id?: string }>) => {
            const { id, ...rest } = action.payload;
            if (id) {
                const idx = state.drafts.findIndex(d => d.id === id);
                if (idx !== -1) {
                    state.drafts[idx] = {
                        ...rest,
                        id,
                        code: rest.code ?? state.drafts[idx].code,
                    };
                    return;
                }
                const code = rest.code ?? generateDraftCode(null, rest.orderDate);
                state.drafts.push({ ...rest, id, code });
                return;
            }
            const newId = Date.now().toString();
            const code = rest.code ?? generateDraftCode(null, rest.orderDate);
            state.drafts.push({ ...rest, id: newId, code });
        },
        deleteDraft: (state, action: PayloadAction<string>) => {
            state.drafts = state.drafts.filter(d => d.id !== action.payload);
        },
    },
});

export const { saveDraft, deleteDraft } = draftsSlice.actions;
export type { DraftOrder } from "../modules/stores/interfaces/DraftOrder";
export type { DraftState } from "../modules/stores/interfaces/DraftState";
export default draftsSlice.reducer;
